import React from "react";
import { CreditCardDetailsProps } from "src/types/credit-card-details-props";
import './credit-card-details.component.sass';
import { useTranslation } from "react-i18next";

export default function CreditCardDetails(props: CreditCardDetailsProps) {
  const { billingDetails, card } = props;
  const [t] = useTranslation();
  return (
    <div className="card-details">
      <div className="name">{billingDetails.name}</div>
      <div className="address">{billingDetails.address + ', ' + billingDetails.postalCode + ' ' + billingDetails.state}</div>
      <div className="card">
				<div className="type">
          { /* @ts-ignore */ }
          <img className="card-icon" src={"/icons/cards/"+card.type.toLowerCase()+".svg"} alt="" width="40px" />
				</div>
				<div className="data">
					{card && card.type + ' - ' + card.mont + '. ' + t("months")}
				</div>
      </div>
    </div>
  );
}
